module.exports = __webpack_public_path__ + "static/media/deepseekai.24511b24.svg";